import axios from 'axios';
import PropTypes from 'prop-types';
import { OPEN_USER_PROMPT } from '../../../actionTypes';
import { API_UPDATE_DEVICE_AUTH_SETTINGS } from '../../../endpoint';
import { consolelog, delCancelToken, showToast } from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  i18nMessages,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { API_ERROR_CODE } from '../../../../lib/constants';

/**
 * デバイス認証設定更新APIを呼び出す
 *
 * @param {string} apiToken - API認証トークン
 * @param {string} apiParams - APIパラメータ
 * @returns
 */
const updateDeviceAuthSettings = (apiToken, apiParams) => dispatch => {
  consolelog('[API CALL] deviceAuthCode()');
  configureAxiosForJSON(apiToken);

  // URLを設定
  const url = API_UPDATE_DEVICE_AUTH_SETTINGS;

  // キャンセルトークンを生成
  const { cancelToken, cancelTokenKey } = createCancelToken('deviceAuthCode');

  return axios
    .patch(url, apiParams, {
      cancelToken,
    })
    .then(res => {
      if (res.status === 200) {
        showToast(i18nMessages['toast.message.company.setting.accessControl']);
      }
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        if (thrown.response && thrown.response.status === 400) {
          const closeButtonLabel = i18nMessages['userPrompt.button.close'];
          dispatch({
            type: OPEN_USER_PROMPT,
            promptMessage: [
              i18nMessages[
                'userPrompt.message.deviceAuth.notSetDefaultGroupSubscriptions'
              ],
            ],
            buttonArray: [{ name: closeButtonLabel }],
          });
        } else if (
          thrown?.response &&
          thrown?.response?.status === 403 &&
          thrown?.response?.data?.errorCode ===
            API_ERROR_CODE.PERMISSION_REQUIRED
        ) {
          const closeButtonLabel = i18nMessages['userPrompt.button.close'];
          dispatch({
            type: OPEN_USER_PROMPT,
            promptMessage: [
              i18nMessages[
                'userPrompt.message.deviceAuth.updateSetting.permissionRequired1'
              ],
              i18nMessages[
                'userPrompt.message.deviceAuth.updateSetting.permissionRequired2'
              ],
              i18nMessages[
                'userPrompt.message.deviceAuth.updateSetting.joinGroup'
              ],
            ],
            buttonArray: [{ name: closeButtonLabel }],
          });
        } else {
          handleErrorResponse(
            thrown,
            dispatch,
            '',
            i18nMessages['userPrompt.message.updateDeviceAuthSettings.error'],
          );
        }
      }
    })
    .finally(() => delCancelToken(cancelTokenKey));
};

updateDeviceAuthSettings.propTypes = {
  apiToken: PropTypes.string.isRequired,
  apiParams: PropTypes.shape({
    subscriptions: PropTypes.arrayOf(PropTypes.number).isRequired,
    ipAddresses: PropTypes.arrayOf(PropTypes.string).isRequired,
    isEnabled: PropTypes.bool.isRequired,
  }).isRequired,
};

export default updateDeviceAuthSettings;
